"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RecordingIndicator = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const ui_react_1 = require("@streem/ui-react");
const room_session_1 = require("../../../../context/room_session");
const logger_1 = require("../../../../util/logger");
const rxjs_1 = require("../../../../hooks/rxjs");
const company_settings_1 = require("../../../../context/company_settings");
const streem_sdk_protobuf_1 = require("streem-sdk-protobuf");
const RecordingIndicator = ({ trayOpen }) => {
    const roomSession = (0, room_session_1.useRoomSession)();
    const companySettings = (0, company_settings_1.useCompanySettings)();
    const theme = (0, ui_react_1.useTheme)();
    const [recordingStatus] = (0, rxjs_1.useObservable)(roomSession.recording.recordingStatus);
    const { addNotification, snackbarNotifications, removeNotification } = (0, ui_react_1.useSnackbar)();
    const [recordingIndicatorMessage, setRecordingIndicatorMessage] = (0, react_1.useState)('');
    const [hover, setHover] = (0, react_1.useState)(false);
    const pausedRecordingId = 'pausedRecording';
    const recordingUnavailableErrorId = 'recordingUnavailableError';
    const recordingIndicatorWidth = (companySettings === null || companySettings === void 0 ? void 0 : companySettings.allowPauseResumeRecording) ? '145px' : '113px';
    const createErrorRecordingSnackItem = (0, react_1.useCallback)((id, message) => {
        removeNotification(id);
        addNotification({
            id: id,
            message: message,
            icon: (0, jsx_runtime_1.jsx)(ui_react_1.AppIcon, { name: "AlertIcon", color: theme.colors.red50, size: "small" }),
            useCloseButton: true,
            onActionClick: () => removeNotification(id),
        });
    }, [addNotification, removeNotification, theme.colors.red50]);
    const handlePauseRecording = (0, react_1.useCallback)(() => __awaiter(void 0, void 0, void 0, function* () {
        const pauseRecordingApiErrorId = 'pauseRecordingApiError';
        try {
            yield roomSession.recording.pauseRecording();
            removeNotification(pauseRecordingApiErrorId);
        }
        catch (error) {
            createErrorRecordingSnackItem(pauseRecordingApiErrorId, 'Pause Recording Error. Please try again.');
            logger_1.logger.error('Error making pause recording request', error);
        }
    }), [roomSession, removeNotification, createErrorRecordingSnackItem]);
    const handleResumeRecording = (0, react_1.useCallback)(() => __awaiter(void 0, void 0, void 0, function* () {
        const resumeRecordingApiErrorId = 'resumeRecordingApiError';
        try {
            yield roomSession.recording.resumeRecording();
            removeNotification(resumeRecordingApiErrorId);
        }
        catch (error) {
            createErrorRecordingSnackItem(resumeRecordingApiErrorId, 'Resume Recording Error. Please try again.');
            logger_1.logger.error('Error making resume recording request', error);
        }
    }), [roomSession, removeNotification, createErrorRecordingSnackItem]);
    const createResumeRecordingSnackItem = (0, react_1.useCallback)(() => {
        removeNotification(recordingUnavailableErrorId);
        addNotification({
            id: pausedRecordingId,
            message: 'The recording has been paused.',
            icon: (0, jsx_runtime_1.jsx)(ui_react_1.AppIcon, { name: "PauseRecordingIcon", color: theme.colors.grey30, iconSize: "28px" }),
            actionMessage: 'Resume',
            onActionClick: () => handleResumeRecording(),
        });
    }, [addNotification, removeNotification, handleResumeRecording, theme.colors.grey30]);
    (0, react_1.useEffect)(() => {
        if (!recordingStatus) {
            return;
        }
        if (recordingStatus === streem_sdk_protobuf_1.streem.api.Artifact.RecordingStatus.RECORDING_STATUS_NONE ||
            recordingStatus === streem_sdk_protobuf_1.streem.api.Artifact.RecordingStatus.RECORDING_STATUS_RESUMED) {
            setRecordingIndicatorMessage('Recording');
            removeNotification(pausedRecordingId);
            removeNotification(recordingUnavailableErrorId);
        }
        if (recordingStatus === streem_sdk_protobuf_1.streem.api.Artifact.RecordingStatus.RECORDING_STATUS_PAUSED) {
            setRecordingIndicatorMessage('Paused');
            createResumeRecordingSnackItem();
        }
        if (recordingStatus ===
            streem_sdk_protobuf_1.streem.api.Artifact.RecordingStatus.RECORDING_STATUS_TEMPORARY_FAILURE) {
            setRecordingIndicatorMessage('Recording Unavailable');
            createErrorRecordingSnackItem(pausedRecordingId, 'Recording error. Call still connected.');
            logger_1.logger.error('Temporary failure reported for recording status');
        }
    }, [
        recordingStatus,
        removeNotification,
        createResumeRecordingSnackItem,
        createErrorRecordingSnackItem,
    ]);
    if (!recordingStatus) {
        return null;
    }
    const isRecording = [
        streem_sdk_protobuf_1.streem.api.Artifact.RecordingStatus.RECORDING_STATUS_NONE,
        streem_sdk_protobuf_1.streem.api.Artifact.RecordingStatus.RECORDING_STATUS_RESUMED,
    ].includes(recordingStatus);
    const isTemporaryFailure = recordingStatus === streem_sdk_protobuf_1.streem.api.Artifact.RecordingStatus.RECORDING_STATUS_TEMPORARY_FAILURE;
    return ((0, jsx_runtime_1.jsxs)(RecordingIndicatorWrapper, Object.assign({ "data-testid": "recording-indicator", isTemporaryFailure: isTemporaryFailure, recordingIndicatorWidth: recordingIndicatorWidth }, { children: [!isTemporaryFailure && ((0, jsx_runtime_1.jsx)(ItemContainer, Object.assign({ marginLeft: "12px" }, { children: (0, jsx_runtime_1.jsx)(ui_react_1.AppIcon, { name: "RecordingIcon", iconSize: "18px", color: isRecording ? theme.colors.red50 : theme.colors.grey40 }) }))), (0, jsx_runtime_1.jsx)(ItemContainer, Object.assign({ margin: "0 0 0 9px" }, { children: (0, jsx_runtime_1.jsx)(ui_react_1.AppText, Object.assign({ color: "white", style: { fontSize: '14px' } }, { children: recordingIndicatorMessage })) })), (companySettings === null || companySettings === void 0 ? void 0 : companySettings.allowPauseResumeRecording) && isRecording && ((0, jsx_runtime_1.jsx)(ItemContainer, { children: (0, jsx_runtime_1.jsx)(ui_react_1.Tooltip, Object.assign({ showTooltip: hover, placement: "bottom-end", fallbackPlacements: ['left', 'top'], message: (0, jsx_runtime_1.jsx)(ui_react_1.AppText, Object.assign({ size: "small" }, { children: "Pause Recording" })) }, { children: (0, jsx_runtime_1.jsx)(ui_react_1.IconButton, { iconName: "PauseRecordingIcon", label: "Pause Recording", background: 'grey80', fill: "white", onMouseEnter: () => setHover(true), onMouseOver: () => setHover(true), onMouseOut: () => setHover(false), onClick: handlePauseRecording }) })) })), (0, jsx_runtime_1.jsx)(ui_react_1.Snackbar, { content: snackbarNotifications, position: { vertical: 'top', horizontal: 'center' }, isTrayOpen: trayOpen })] })));
};
exports.RecordingIndicator = RecordingIndicator;
const RecordingIndicatorWrapper = (0, ui_react_1.styled)(ui_react_1.Flex)(({ isTemporaryFailure, recordingIndicatorWidth, theme }) => ({
    display: 'flex',
    width: isTemporaryFailure ? '157px' : recordingIndicatorWidth,
    height: '42px',
    borderRadius: '4px',
    alignItems: 'center',
    position: 'absolute',
    zIndex: 9999,
    background: theme.colors.grey80,
    top: 15,
    left: 12,
}));
const ItemContainer = (0, ui_react_1.styled)(ui_react_1.Flex)(() => ({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
}));
//# sourceMappingURL=recording_indicator.js.map